<template><SimpleModuleDashboard :module-id="Modules.EMPLEADOS" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'crudEmployee', reference: 'crudEmployee', route: 'EmployeeStaffCrudEmployee', tone: 'primary' },
  { id: 'crudCategory', reference: 'crudCategory', route: 'EmployeetStaffCrudCategory', tone: 'primary', group: 'Configuraciones' },
] }) }
</script>
